import { supabase, handleSupabaseError } from '@/lib';

/** Members in the House right now, split by how they are counted. */
export interface InTheHouseCount {
  total: number;
  /** Locker key issued today and not returned yet. */
  withKey: number;
  /** No key since their last check-in; inside the no-key window. */
  byTimer: number;
}

/**
 * The one "In the House" read for every admin tile. The rule (open key today,
 * or checked in within IN_THE_HOUSE_NO_KEY_MINUTES with no key returned since)
 * runs server-side in get_members_in_house_count — migration 20261015100000 —
 * the same definition hok-mobile's Members tab reads, so staff and members see
 * the same people. Counts members, not check-in rows: a re-entry is one person.
 */
export async function fetchInTheHouse(): Promise<InTheHouseCount> {
  const { data, error } = await supabase.rpc('get_members_in_house_count');
  if (error) handleSupabaseError(error, { operation: 'fetching in-the-house count' });
  const doc = (data ?? {}) as { total?: number; with_key?: number; by_timer?: number };
  return {
    total: doc.total ?? 0,
    withKey: doc.with_key ?? 0,
    byTimer: doc.by_timer ?? 0,
  };
}
